import { Navigate, Route, Routes } from 'react-router'
import { NotFound } from '../components/NotFound'
import OrderLayout from '../components/OrderLayout'
import OrderPage from '../pages/OrderPage'

const EditOrderPage = () => {
  return (
    <div>
      <h1>Edit order page</h1>
    </div>
  )
}

export default function OrderRouter() {
  return (
    <Routes>
      <Route index element={<Navigate to="/" />} />
      <Route element={<OrderLayout />}>
        <Route path=":rfqId" element={<OrderPage />} />
        <Route path=":rfqId/edit" element={<EditOrderPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
